import { HttpStatusCode } from "axios";
import { alertConstants } from "../../helper/sweet-alert";
import TaskService from "../../apiServices/masters/taskService";
import { setTask, setTasks } from "../../store/slices/master/taskSlice";

export function getTask(id: number) {
  return async function (dispatch: any, getState: any) {
    let response = await TaskService.getTask(id);
    if (response?.success === true) {
      dispatch(setTask(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getTasks(
  noOfItems?: number
) {
  return async function (dispatch: any, getState: any) {
    let response = await TaskService.getTasks(noOfItems);
    if (response?.success === true) {
      dispatch(setTasks(response.data));
    } else {
      console.log("error");
    }
  };
}

export function createTask(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await TaskService.createTask(data);
    const name = data.name;
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict, name);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateTask(data: any, id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await TaskService.updateTask(data, id);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function deleteTask(id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await TaskService.deleteTask(id);
    if (response === true) {
      callback(alertConstants.deleteSuccess);
    } else {
      callback(alertConstants.deleteFailure);
    }
  };
}
